/* eslint-disable max-len */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable quote-props */
export default {
  data: {
    links: [
      {
        description: 'More information about breast cancer trials',
        url: 'http://www.bccancer.bc.ca/our-research/participate/clinical-trials/open-clinical-trials/bc-cancer%E2%80%93vancouver',
      },
    ],
    is_processed: false,
    brief_title:
      'A Study To Evaluate the Efficacy and Safety Of Atezolizumab or Placebo in Combination With Neoadjuvant Doxorubicin + Cyclophosphamide Followed By Paclitaxel + Trastuzumab + Pertuzumab In Early Her2-Positive Breast Cancer',
    conditions: ['Breast Cancer'],
    detailed_description: {},
    eligibility: {
      criteria: {
        inclusion: [
          'Confirmed diagnosis of HER2-positive breast cancer, and hormonal and PD-L1 status, as documented through central testing of a representative tumor tissue specimen',
          'Primary breast tumor size of > 2 cm by any radiographic measurement',
          'Stage at presentation: T2-T4, N1-N3, M0 as determined by AJCC staging system, 8th edition',
          'Pathologic confirmation of nodal involvement with malignancy must be determined by fine needle aspiration or core-needle biopsy. Surgical excision of lymph nodes is not permitted.',
          'Patients with multifocal tumors are eligible provided at least one focus is sampled and centrally confirmed as HER2-positive.',
          'Patients with multicentric tumors are eligible provided all discrete lesions are sampled and centrally confirmed as HER2-positive.',
          'Eastern Cooperative Oncology Group Performance Status of 0 or 1',
          'Baseline LVEF >= 55% measured by echocardiogram (ECHO) or multiple-gated acquisition (MUGA) scans',
          'Adequate hematologic and end-organ function obtained within 14 days prior to initiation of study treatment',
          'For women of childbearing potential: agreement to remain abstinent or use contraceptive methods, and agreement to refrain from donating eggs',
          'For men: agreement to remain abstinent or use contraceptive measures, and agreement to refrain from donating sperm',
          'For patients enrolled in the extended China enrollment phase: current resident of mainland China and of Chinese ancestry (the China subpopulation will consist of patients enrolled at sites in mainland China and Taiwan who are of Chinese ancestry)',
        ],
        exclusion: [
          'Prior history of invasive breast cancer',
          'Stage IV (metastatic) breast cancer',
          'Patients with synchronous bilateral invasive breast cancer',
          'Prior systemic therapy for treatment of breast cancer',
          'Previous therapy with anthracyclines or taxanes for any malignancy',
          'Ulcerating or inflammatory breast cancer',
          'Undergone incisional and/or excisional biopsy of primary tumor and/or axillary lymph nodes',
          'Sentinel lymph node procedure or axillary lymph node dissection prior to initiation of neoadjuvant therapy',
          'History of other malignancy within 5 years prior to screening, with the exception of those patients who have a negligible risk of metastasis or death',
          'Cardiopulmonary dysfunction',
          'Dyspnea at rest',
          'Active or history of autoimmune disease or immune deficiency',
          'Pregnancy or breastfeeding, or intention of becoming pregnant during study treatment or within 5 months after the final dose of atezolizumab/placebo, 6 months after the final dose of doxorubicin, 12 months after the final dose of cyclophosphamide, 6 months after the final dose of paclitaxel, or 7 months after the final dose of trastuzumab, pertuzumab, or trastuzumab emtansine whichever occurs last',

          // Exclusion Criteria Related to Trastuzumab Emtansine in the Adjuvant Setting:
          'Patients who achieved pCR',
          'Evidence of clinically evident gross residual or recurrent disease following neoadjuvant therapy and surgery',
          'Unable to complete surgery with curative intent after conclusion of neoadjuvant systemic therapy',
          'Patient discontinued treatment with trastuzumab because of toxicity during the neoadjuvant phase of the study',
          'Clinically significant history of liver disease, including cirrhosis, current alcohol abuse, autoimmune hepatic disorders, or sclerosis cholangitis',
          'Patients with Grade >=2 peripheral neuropathy',
          'Prior treatment with trastuzumab emtansine',
        ],
        textblock:
          'Inclusion Criteria:\n\n          -  Confirmed diagnosis of HER2-positive breast cancer, and hormonal and PD-L1 status, as\n             documented through central testing of a representative tumor tissue specimen\n\n          -  Primary breast tumor size of > 2 cm by any radiographic measurement\n\n          -  Stage at presentation: T2-T4, N1-N3, M0 as determined by AJCC staging system, 8th\n             edition\n\n          -  Pathologic confirmation of nodal involvement with malignancy must be determined by\n             fine needle aspiration or core-needle biopsy. Surgical excision of lymph nodes is not\n             permitted.\n\n          -  Patients with multifocal tumors are eligible provided at least one focus is sampled\n             and centrally confirmed as HER2-positive.\n\n          -  Patients with multicentric tumors are eligible provided all discrete lesions are\n             sampled and centrally confirmed as HER2-positive.\n\n          -  Eastern Cooperative Oncology Group Performance Status of 0 or 1\n\n          -  Baseline LVEF >= 55% measured by echocardiogram (ECHO) or multiple-gated acquisition\n             (MUGA) scans\n\n          -  Adequate hematologic and end-organ function obtained within 14 days prior to\n             initiation of study treatment\n\n          -  For women of childbearing potential: agreement to remain abstinent or use\n             contraceptive methods, and agreement to refrain from donating eggs\n\n          -  For men: agreement to remain abstinent or use contraceptive measures, and agreement to\n             refrain from donating sperm\n\n          -  For patients enrolled in the extended China enrollment phase: current resident of\n             mainland China and of Chinese ancestry (the China subpopulation will consist of\n             patients enrolled at sites in mainland China and Taiwan who are of Chinese ancestry)\n\n        Exclusion Criteria:\n\n          -  Prior history of invasive breast cancer\n\n          -  Stage IV (metastatic) breast cancer\n\n          -  Patients with synchronous bilateral invasive breast cancer\n\n          -  Prior systemic therapy for treatment of breast cancer\n\n          -  Previous therapy with anthracyclines or taxanes for any malignancy\n\n          -  Ulcerating or inflammatory breast cancer\n\n          -  Undergone incisional and/or excisional biopsy of primary tumor and/or axillary lymph\n             nodes\n\n          -  Sentinel lymph node procedure or axillary lymph node dissection prior to initiation of\n             neoadjuvant therapy\n\n          -  History of other malignancy within 5 years prior to screening, with the exception of\n             those patients who have a negligible risk of metastasis or death\n\n          -  Cardiopulmonary dysfunction\n\n          -  Dyspnea at rest\n\n          -  Active or history of autoimmune disease or immune deficiency\n\n          -  Pregnancy or breastfeeding, or intention of becoming pregnant during study treatment\n             or within 5 months after the final dose of atezolizumab/placebo, 6 months after the\n             final dose of doxorubicin, 12 months after the final dose of cyclophosphamide, 6\n             months after the final dose of paclitaxel, or 7 months after the final dose of\n             trastuzumab, pertuzumab, or trastuzumab emtansine whichever occurs last\n\n        Exclusion Criteria Related to Trastuzumab Emtansine in the Adjuvant Setting:\n\n          -  Patients who achieved pCR\n\n          -  Evidence of clinically evident gross residual or recurrent disease following\n             neoadjuvant therapy and surgery\n\n          -  Unable to complete surgery with curative intent after conclusion of neoadjuvant\n             systemic therapy\n\n          -  Patient discontinued treatment with trastuzumab because of toxicity during the\n             neoadjuvant phase of the study\n\n          -  Clinically significant history of liver disease, including cirrhosis, current alcohol\n             abuse, autoimmune hepatic disorders, or sclerosis cholangitis\n\n          -  Patients with Grade >=2 peripheral neuropathy\n\n          -  Prior treatment with trastuzumab emtansine',
      },
      gender: 'All',
      healthy_volunteers: 'No',
      maximum_age: 'N/A',
      minimum_age: '18 Years',
    },
    id: 'NCT03726879',
    interventions: [
      {
        arm_group_label: 'Atezolizumab +ddAC-PacHP',
        description:
          'Atezolizumab will be administered as per the schedule specified in the respective arm.',
        intervention_name: 'Atezolizumab',
        intervention_type: 'Drug',
        other_name: 'Tecentriq',
      },
      {
        arm_group_label: 'Placebo + ddAC-PacHP',
        description:
          'Placebo matched to atezolizumab will be administered as per the schedule specified in the respective arm.',
        intervention_name: 'Placebo',
        intervention_type: 'Drug',
      },
      {
        arm_group_label: ['Atezolizumab +ddAC-PacHP', 'Placebo + ddAC-PacHP'],
        description:
          'Doxorubicin will be administered as per the schedule specified in the respective arm.',
        intervention_name: 'Doxorubicin',
        intervention_type: 'Drug',
        other_name: 'Adriamycin',
      },
      {
        arm_group_label: ['Atezolizumab +ddAC-PacHP', 'Placebo + ddAC-PacHP'],
        description:
          'Cyclophosphamide will be administered as per the schedule specified in the respective arm.',
        intervention_name: 'Cyclophosphamide',
        intervention_type: 'Drug',
        other_name: ['Cytoxan', 'Neosar'],
      },
      {
        arm_group_label: ['Atezolizumab +ddAC-PacHP', 'Placebo + ddAC-PacHP'],
        description:
          'Paclitaxel will be administered as per the schedule specified in the respective arm.',
        intervention_name: 'Paclitaxel',
        intervention_type: 'Drug',
        other_name: 'Taxol',
      },
      {
        arm_group_label: ['Atezolizumab +ddAC-PacHP', 'Placebo + ddAC-PacHP'],
        description:
          'Trastuzumab will be administered as per the schedule specified in the respective arm.',
        intervention_name: 'Trastuzumab',
        intervention_type: 'Drug',
        other_name: 'Herceptin',
      },
      {
        arm_group_label: ['Atezolizumab +ddAC-PacHP', 'Placebo + ddAC-PacHP'],
        description:
          'Pertuzumab will be administered as per the schedule specified in the respective arm.',
        intervention_name: 'Pertuzumab',
        intervention_type: 'Drug',
        other_name: 'Perjeta',
      },
      {
        arm_group_label: ['Atezolizumab +ddAC-PacHP', 'Placebo + ddAC-PacHP'],
        description:
          'Participants without pCR have the option of receiving adjuvant atezolizumab/placebo combined with Trastuzumab Emtansine 3.6 mg/kg IV Q3W.',
        intervention_name: 'Trastuzumab Emtansine',
        intervention_type: 'Drug',
        other_name: 'Kadcyla',
      },
    ],
    locations: [
      {
        facility: {
          address: {
            city: 'New Haven',
            country: 'United States',
            state: 'Connecticut',
            zip: '06520',
          },
          name: 'Yale Cancer Center',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Baltimore',
            country: 'United States',
            state: 'Maryland',
            zip: '21202',
          },
          name: 'Mercy Medical Center',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Kansas City',
            country: 'United States',
            state: 'Missouri',
            zip: '64132',
          },
          name: 'HCA Midwest Division',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'New York',
            country: 'United States',
            state: 'New York',
            zip: '10016',
          },
          name: 'New York University Medical Center PRIME; NYU Langone Medical Center',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'New York',
            country: 'United States',
            state: 'New York',
            zip: '10065',
          },
          name: 'Memorial Sloan Kettering Cancer Center',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Portland',
            country: 'United States',
            state: 'Oregon',
            zip: '97225',
          },
          name: 'Providence Portland Medical Ctr',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Nashville',
            country: 'United States',
            state: 'Tennessee',
            zip: '37203',
          },
          name: 'Tennessee Oncology',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Nashville',
            country: 'United States',
            state: 'Tennessee',
            zip: '37232',
          },
          name: 'Vanderbilt',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'San Antonio',
            country: 'United States',
            state: 'Texas',
            zip: '78229',
          },
          name: 'Cancer Therapy and Research Center CTRC at UTHSCSA',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Salvador',
            country: 'Brazil',
            state: 'BA',
            zip: '41253-190',
          },
          name: 'Hospital Sao Rafael - HSR',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Goiania',
            country: 'Brazil',
            state: 'GO',
            zip: '74605-070',
          },
          name: 'Hospital Araujo Jorge; Departamento de Ginecologia E Mama',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Rio de Janeiro',
            country: 'Brazil',
            state: 'RJ',
            zip: '20560-120',
          },
          name: 'Instituto Nacional de Cancer - INCa; Oncologia',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Porto Alegre',
            country: 'Brazil',
            state: 'RS',
            zip: '90610-000',
          },
          name: 'Hospital Sao Lucas - PUCRS',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Porto Alegre',
            country: 'Brazil',
            state: 'RS',
            zip: '91350-200',
          },
          name: 'Hospital Nossa Senhora da Conceicao',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Sao Paulo',
            country: 'Brazil',
            state: 'SP',
            zip: '01317-000',
          },
          name: 'Hospital Perola Byington',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Calgary',
            country: 'Canada',
            state: 'Alberta',
            zip: 'T2N 4N2',
          },
          name: 'Tom Baker Cancer Centre-Calgary',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Vancouver',
            country: 'Canada',
            state: 'British Columbia',
            zip: 'V5Z 4E6',
          },
          name: 'BCCA-Vancouver Cancer Centre',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Montr\u00e9al',
            country: 'Canada',
            state: 'Quebec',
            zip: 'H3T 1E2',
          },
          name: 'Jewish General Hospital; Research Unit',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Quebec City',
            country: 'Canada',
            state: 'Quebec',
            zip: 'G1S 4L8',
          },
          name: 'CHU de Qu\u00e9bec - H\u00f4pital du Saint-Sacrement',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Beijing',
            country: 'China',
            zip: '100044',
          },
          name: "Peking University People's Hospital",
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Guangzhou',
            country: 'China',
            zip: '510000',
          },
          name: 'Sun Yat-sen Memorial Hospital',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Hangzhou City',
            country: 'China',
            zip: '310022',
          },
          name: 'Zhejiang Cancer Hospital; Breast Surgery',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Harbin',
            country: 'China',
            zip: '150081',
          },
          name: 'Harbin Medical University Cancer Hospital',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Nanjing',
            country: 'China',
            zip: '210036',
          },
          name: 'Jiangsu Province Hospital',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Shanghai City',
            country: 'China',
            zip: '200120',
          },
          name: 'Fudan University Shanghai Cancer Center',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Zhengzhou',
            country: 'China',
            zip: '450008',
          },
          name: 'Henan Cancer Hospital',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Brno',
            country: 'Czechia',
            zip: '656 53',
          },
          name: 'Masarykuv onkologicky ustav',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Olomouc',
            country: 'Czechia',
            zip: '779 00',
          },
          name: 'Fakultni nemocnice Olomouc; Onkologicka klinika',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Pardubice',
            country: 'Czechia',
            zip: '532 03',
          },
          name: 'Multiscan s.r.o.',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Bad Nauheim',
            country: 'Germany',
            zip: '61231',
          },
          name: 'Hochwaldkrankenhaus; Abt.Gyn\u00e4kologie Geburtshilfe u.Senologie',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Essen',
            country: 'Germany',
            zip: '45136',
          },
          name: 'Klinikum Essen-Mitte Ev. Huyssens-Stiftung / Knappschafts GmbH; Klinik f\u00fcr Senologie / Brustzentrum',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Frankfurt am Main',
            country: 'Germany',
            zip: '60389',
          },
          name: 'H\u00e4matologisch-Onkologische Gemeinschaftspraxis am Bethanien-Krankenhaus',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Freiburg',
            country: 'Germany',
            zip: '79110',
          },
          name: 'Praxis f\u00fcr Interdisziplin\u00e4re Onkologie und H\u00e4matologie GbR',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Hamburg',
            country: 'Germany',
            zip: '20357',
          },
          name: 'Kooperatives Mammazentrum Hamburg Krankenhaus Jerusalem',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Leipzig',
            country: 'Germany',
            zip: '04277',
          },
          name: 'Sankt Elisabeth Krankenhaus; Gynaekology',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Muenchen',
            country: 'Germany',
            zip: '80637',
          },
          name: 'Rotkreuzklinikum M\u00fcnchen; Frauenklinik',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'M\u00fcnster',
            country: 'Germany',
            zip: '48149',
          },
          name: 'Universit\u00e4tsklinikum M\u00fcnster; Klinik f\u00fcr Frauenheilkunde und Geburtshilfe',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Paderborn',
            country: 'Germany',
            zip: '33098',
          },
          name: 'St. Vincenz-Krankenhaus Paderborn; Haus 3 Frauenklinik',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Trier',
            country: 'Germany',
            zip: '54290',
          },
          name: 'Mutterhaus der Borrom\u00e4erinnen gGmbH, Abteilung H\u00e4matologie-Onkologie',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Ulm',
            country: 'Germany',
            zip: '89075',
          },
          name: 'Universit\u00e4tsfrauenklinik Ulm; Abteilung Gyn\u00e4kologie',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Napoli',
            country: 'Italy',
            state: 'Campania',
            zip: '80131',
          },
          name: 'Istituto Nazionale Tumori Irccs Fondazione g. PASCALE;U.O.C. Oncologia Medica Senologica',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Napoli',
            country: 'Italy',
            state: 'Campania',
            zip: '80131',
          },
          name: 'Universit\u00e0 degli Studi Federico II; Clinica di Oncologia Medica',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Aviano',
            country: 'Italy',
            state: 'Friuli-Venezia Giulia',
            zip: '33081',
          },
          name: 'Irccs Centro Di Riferimento Oncologico (CRO); Dipartimento Di Oncologia Medica',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Roma',
            country: 'Italy',
            state: 'Lazio',
            zip: '00168',
          },
          name: 'Policlinico Universitario Agostino Gemelli',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Brescia',
            country: 'Italy',
            state: 'Lombardia',
            zip: '25123',
          },
          name: 'ASST DEGLI SPEDALI CIVILI DI BRESCIA; Oncologia Medica',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Lecco',
            country: 'Italy',
            state: 'Lombardia',
            zip: '23900',
          },
          name: 'ASST DI LECCO; Oncologia Medica',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Monza',
            country: 'Italy',
            state: 'Lombardia',
            zip: '20900',
          },
          name: 'ASST DI MONZA; Oncologia Medica',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Rozzano',
            country: 'Italy',
            state: 'Lombardia',
            zip: '20089',
          },
          name: 'Istituto Clinico Humanitas;U.O. Oncologia Medica Ed Ematologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Candiolo',
            country: 'Italy',
            state: 'Piemonte',
            zip: '10060',
          },
          name: "Fondazione Del Piemonte Per L'oncologia Ircc Di Candiolo; Dipartimento Oncologico",
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Cona (Ferrara)',
            country: 'Italy',
            state: 'Veneto',
            zip: '44124',
          },
          name: 'Arcispedale S.Anna; Oncologia Medica',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Padova',
            country: 'Italy',
            state: 'Veneto',
            zip: '35128',
          },
          name: 'IOV - Istituto Oncologico Veneto - IRCCS; Oncologia Medica II',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Ehime',
            country: 'Japan',
            zip: '791-0280',
          },
          name: 'National Hospital Organization Shikoku Cancer Center',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Fukuoka',
            country: 'Japan',
            zip: '811-1395',
          },
          name: 'National Hospital Organization Kyushu Cancer Center',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Fukushima',
            country: 'Japan',
            zip: '960-1295',
          },
          name: 'Fukushima Medical University Hospital',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Hiroshima',
            country: 'Japan',
            zip: '730-8518',
          },
          name: 'Hiroshima City Hiroshima Citizens Hospital',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Hiroshima',
            country: 'Japan',
            zip: '734-8551',
          },
          name: 'Hiroshima University Hospital',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Hokkaido',
            country: 'Japan',
            zip: '003-0804',
          },
          name: 'National Hospital Organization Hokkaido Cancer Center',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Hyogo',
            country: 'Japan',
            zip: '673-0021',
          },
          name: 'Hyogo Cancer Center',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Kanagawa',
            country: 'Japan',
            zip: '241-8515',
          },
          name: 'Kanagawa Cancer Center',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Kanagawa',
            country: 'Japan',
            zip: '259-1193',
          },
          name: 'Tokai University Hospital',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Kumamoto',
            country: 'Japan',
            zip: '862-8655',
          },
          name: 'Kumamoto Shinto General Hospital',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Niigata',
            country: 'Japan',
            zip: '951-8566',
          },
          name: 'Niigata Cancer Center Hospital',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Osaka',
            country: 'Japan',
            zip: '540-0006',
          },
          name: 'National Hospital Organization Osaka National Hospital',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Saitama',
            country: 'Japan',
            zip: '350-1298',
          },
          name: 'Saitama Medical University International Medical Center',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Tokyo',
            country: 'Japan',
            zip: '105-8470',
          },
          name: 'Toranomon Hospital',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Tokyo',
            country: 'Japan',
            zip: '142-8666',
          },
          name: 'Showa University Hospital',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Tokyo',
            country: 'Japan',
            zip: '162-8655',
          },
          name: 'Center Hospital of the National Center for Global Health and Medicine',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Incheon',
            country: 'Korea, Republic of',
            zip: '21565',
          },
          name: 'Gachon University Gil Medical Center',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Seoul',
            country: 'Korea, Republic of',
            zip: '02841',
          },
          name: 'Korea University Anam Hospital',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Seoul',
            country: 'Korea, Republic of',
            zip: '03080',
          },
          name: 'Seoul National University Hospital',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Seoul',
            country: 'Korea, Republic of',
            zip: '135-170',
          },
          name: 'Samsung Medical Centre; Oncology',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Gliwice',
            country: 'Poland',
            zip: '44-101',
          },
          name: 'Centrum Onkologii - Instytut im. Marii Sk\u0142odowskiej-Curie; Cent. Diagnostyki i Terapii Chorob Piersi',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Grudzi\u0105dz',
            country: 'Poland',
            zip: '86-300',
          },
          name: 'Regionalny Szpital Specjalistyczny im. W. Bieganskiego; Oddzial Onkologii Klinicznej',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Krak\u00f3w',
            country: 'Poland',
            zip: '30-688',
          },
          name: 'Szpital Uniwersytecki w Krakowie, Oddzia\u0142 Kliniczny Kliniki Onkologii',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Warszawa',
            country: 'Poland',
            zip: '02-781',
          },
          name: 'Cent.Onkologii-Instytut im. M. S-Curie, Klinika Now. Piersi i Chirurgii Rekon',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Wroc\u0142aw',
            country: 'Poland',
            zip: '53-413',
          },
          name: 'Dolnoslaskie Centrum Onkologii',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: '\u0141\u00f3d\u017a',
            country: 'Poland',
            zip: '93-338',
          },
          name: 'Instytut "Centrum Zdrowia Matki Polki"; Klinika Onkologii',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Obninsk',
            country: 'Russian Federation',
            state: 'Kaluga',
            zip: '249036',
          },
          name: 'FSBI National Medical Research Radiological Center; A. TSYB MEDICAL RADIOLOGICAL RESEARCH CENTER',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Pesochny',
            country: 'Russian Federation',
            state: 'Leningrad',
            zip: '197758',
          },
          name: 'Petrov Research Inst. of Oncology',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Moskva',
            country: 'Russian Federation',
            state: 'Moskovskaja Oblast',
            zip: '111123',
          },
          name: 'SBIH "Moscow Clinical Scientific and Practical Center named after A.S. Loginov of DHM"',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Kazan',
            country: 'Russian Federation',
            zip: '420029',
          },
          name: 'Republican Clinical Oncology Dispensary of Ministry of Healthcare of Tatarstan Republic',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Moscow',
            country: 'Russian Federation',
            zip: '115478',
          },
          name: 'Blokhin Cancer Research Center; Combined Treatment',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Moscow',
            country: 'Russian Federation',
            zip: '125284',
          },
          name: 'P.A. Gertsen Cancer Research Inst. ; Chemotherapy Dept',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Moscow',
            country: 'Russian Federation',
            zip: '143423',
          },
          name: 'City Clinical Oncology Hospital',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Tomsk',
            country: 'Russian Federation',
            zip: '634028',
          },
          name: 'Tomsk National Research Medical Center RAS; Research Intitute of Oncology',
        },
        status: 'Withdrawn',
      },
      {
        facility: {
          address: {
            city: 'Badalona',
            country: 'Spain',
            state: 'Barcelona',
            zip: '08916',
          },
          name: 'Hospital Universitari Germans Trias i Pujol; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'El Palmar',
            country: 'Spain',
            state: 'Murcia',
            zip: '30120',
          },
          name: 'Hospital Universitario Virgen de La Arrixaca; Servicio De Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Pamplona',
            country: 'Spain',
            state: 'Navarra',
            zip: '31008',
          },
          name: 'Clinica Universitaria de Navarra; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Barcelona',
            country: 'Spain',
            zip: '08035',
          },
          name: "Hospital Univ Vall d'Hebron; Servicio de Oncologia",
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Barcelona',
            country: 'Spain',
            zip: '08036',
          },
          name: 'Hospital Cl\u00ednic i Provincial; Servicio de Hematolog\u00eda y Oncolog\u00eda',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Burgos',
            country: 'Spain',
            zip: '09006',
          },
          name: 'Complejo Asistencial Universitario De Burgos; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Granada',
            country: 'Spain',
            zip: '18003',
          },
          name: 'Hospital Clinico de Granada; Servicio de Oncologia',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Jaen',
            country: 'Spain',
            zip: '23007',
          },
          name: 'Complejo Hospitalario de Jaen-Hospital Universitario Medico Quirurgico; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Lerida',
            country: 'Spain',
            zip: '25198',
          },
          name: 'Hospital Universitari Arnau de Vilanova de Lleida; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Madrid',
            country: 'Spain',
            zip: '28027',
          },
          name: 'Clinica Universidad de Navarra Madrid; Servicio de Oncolog\u00eda',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Madrid',
            country: 'Spain',
            zip: '28041',
          },
          name: 'Hospital Universitario 12 de Octubre; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Madrid',
            country: 'Spain',
            zip: '28050',
          },
          name: 'Centro Integral Oncologico Clara Campal; Servicio de Oncolog\u00eda',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Sevilla',
            country: 'Spain',
            zip: '41009',
          },
          name: 'Hospital Universitario Virgen Macarena; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Sevilla',
            country: 'Spain',
            zip: '41013',
          },
          name: 'Hospital Universitario Virgen del Rocio; Servicio de Oncologia',
        },
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Zaragoza',
            country: 'Spain',
            zip: '50009',
          },
          name: 'Hospital Universitario Miguel Servet; Servicio Oncologia',
        },
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Taichung',
            country: 'Taiwan',
            zip: '404',
          },
          name: 'China Medical University Hospital; Surgery',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Taipei City',
            country: 'Taiwan',
            zip: '11259',
          },
          name: 'Koo Foundation Sun Yat-Sen Cancer Center; Hemato-Oncology',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Taipei',
            country: 'Taiwan',
            zip: '104',
          },
          name: 'Mackay Memorial Hospital; Dept of Surgery',
        },
        status: 'Active, not recruiting',
      },
      {
        facility: {
          address: {
            city: 'Taoyuan',
            country: 'Taiwan',
            zip: '333',
          },
          name: 'Chang Gung Medical Foundation - Linkou; Dept of Surgery',
        },
        status: 'Recruiting',
      },
    ],
    overall_contact: {
      email: 'global-roche-genentech-trials@gene.com',
      last_name:
        'Reference Study ID Number: BO40747 www.roche.com/about_roche/roche_worldwide.htm',
      phone: '888-662-6728 (U.S. and Canada)',
    },
    overall_contact_backup: {},
    overall_status: 'Recruiting',
    phase: 'Phase 3',
  },
};
